import { CommonModule } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import { Component } from '@angular/core';
import { Router, RouterModule } from '@angular/router';
// import { MsalBroadcastService, MsalService } from '@azure/msal-angular';
// import { InteractionStatus } from '@azure/msal-browser';
import { NgxSpinnerModule, NgxSpinnerService } from 'ngx-spinner';
import { HeaderService } from '../../services/header.service';
import { CompanyService } from '../../../features/services/company.service';

@Component({
  selector: 'app-voucher-landing',
  standalone: true,
  imports: [RouterModule, CommonModule, NgxSpinnerModule],
  templateUrl: './voucher-landing.component.html',
  styleUrl: './voucher-landing.component.css'
})
export class VoucherLandingComponent {
  constructor(
    // private msalService: MsalService,
    // private msalBroadcastService: MsalBroadcastService,
    private ngx: NgxSpinnerService,
    private http: HttpClient,
    private router: Router,
    private headerService: HeaderService,
    private companyService: CompanyService,
  ) { }

  ngOnInit(): void {
    this.callSecureApi();
    // this.msalService.handleRedirectObservable().subscribe();
    // this.msalBroadcastService.inProgress$
    //   .subscribe((status: InteractionStatus) => {

    //     if (status !== InteractionStatus.None) {
    //       this.ngx.show();
    //     } else {
    //       this.ngx.hide();
    //     }
    //   });

    // const account = this.msalService.instance.getActiveAccount();
    // if (account) {
    //   this.ngx.show();
    //   this.callSecureApi();
    // }

    // const accounts = this.msalService.instance.getAllAccounts()
    // if (accounts.length === 0) {
    // }
  }

  // callSecureApi(): void {
  //   this.msalService.acquireTokenSilent({
  //     scopes: ['openid', 'email', 'api://6f8a5994-72ce-44a7-8377-3d85e9942e18/access_as_user']
  //   }).subscribe(token => {
  //     this.http.get<any>('https://tdvoucherselfserviceapi-gbhydwckgxdue7d0.northcentralus-01.azurewebsites.net/api/secure', {
  //       headers: {
  //         Authorization: `Bearer ${token.accessToken}`
  //       }
  //     }).subscribe({
  //       next: res => {
  //         sessionStorage.setItem('companyId', res.companyId);
  //         sessionStorage.setItem('email', res.email);
  //         sessionStorage.setItem('roleCode', res.roleCode);
  //         sessionStorage.setItem('companyName', res.companyName);
  //         this.headerService.setCompanyName(res.companyName);
  //         this.ngx.hide();
  //         this.router.navigate(['/home']);
  //       },
  //       error: err => {
  //         this.ngx.hide();
  //         console.error('API error', err);
  //       }
  //     });
  //   });
  // }

   callSecureApi(): void {
    this.companyService.secure().subscribe({
        next: res => {
          sessionStorage.setItem('companyId', res.companyId);
          sessionStorage.setItem('email', res.userEmail);
          sessionStorage.setItem('roleCode', res.roleCode);
          sessionStorage.setItem('companyName', res.companyName);
          this.headerService.setCompanyName(res.companyName);
          this.ngx.hide();
          this.router.navigate(['/home']);
        },
        error: err => {
          this.ngx.hide();
          console.error('API error', err);
        }
      });   
  }
}
